<template>
  <div class="bg-cl-white body-box dp-flex jtf-ct-center al-it-center f-drt-column">
    <div class="w-100pct bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center">
      ตั้งค่าสาขา
    </div>
    <div class="w-80pct mg-vtc-10px">
      <b-select v-model="selectBranch" expanded>
        <option value="" disabled>เลือกสาขา</option>
        <option v-for="(branch, index) in branchs" :key="index" :value="branch">
          {{ branch.name }}
        </option>
      </b-select>
    </div>
    <div v-if="selectBranch !== ''" class="w-80pct mg-vtc-10px">
      <b-select v-model="selectPOS" expanded>
        <option value="" disabled>POS ID</option>
        <option v-for="(pos, index) in selectBranch.posID" :key="index" :value="index">
          {{ pos }}( {{ selectBranch.posWarehouseDisplayName[index] }} )
        </option>
      </b-select>
    </div>
    <div class="w-80pct mg-vtc-10px pd-vtc-10px cl-white cs-pointer bd-rd-4px f-w-bold t-al-center" :style="`background-color: ${mainColor};`">
      <div @click="confirmSelect()">
        ตกลง
      </div>
    </div>
    <div class="w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold" v-if="cancelBtn">
      <div @click="cancel()">
        ยกเลิก
      </div>
    </div>
    <div class="w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold t-al-center" v-else>
      <div @click="logout()">
        ออกจากระบบ
      </div>
    </div>
  </div>
</template>

<script>
import { getBranchID } from '@/utils/helper/localStorage'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'selectStore',
  data () {
    return {
      selectBranch: '',
      selectPOS: '',
      currentBranchPOS: ''
    }
  },
  props: [
    'cancelBtn'
  ],
  methods: {
    ...mapActions({
      fetchBranch: 'fetchBranch',
      initState: 'initState',
      clearAllData: 'clearAllData',
      setSellsukiAuth: 'setSellsukiAuth',
      setIsloading: 'setIsloading',
      init: 'init'
    }),
    async confirmSelect () {
      if (this.selectBranch === '' || this.selectPOS === '') {
        return
      }
      let results = {
        branch_id: this.selectBranch.id,
        store_id: this.selectBranch.store_id,
        unit_id: this.selectBranch.unitID[this.selectPOS],
        warehouse: this.selectBranch.posWarehouse[this.selectPOS],
        tax_id: this.selectBranch.tax_id,
        name: this.selectBranch.name,
        warehouse_display_name: this.selectBranch.posWarehouseDisplayName[this.selectPOS],
        pos_id: this.selectBranch.posID[this.selectPOS]
      }
      this.setIsloading(true)
      window.localStorage.setItem('currentBranchPOS', JSON.stringify(results))
      this.initState()
      this.clearAllData()
      await this.init()
      this.setIsloading(false)
      window.location.reload()
    },
    cancel () {
      this.$parent.close()
    },
    logout () {
      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: () => {
          this.setSellsukiAuth('')
          window.localStorage.removeItem('currentBranchPOS')
          window.location.href = process.env.SELLSUKI_LOGOUT_PORTAL
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      branchs: 'getBranch',
      mainColor: 'mainColor'
    })
  },
  async mounted () {
    this.setIsloading(true)
    await this.fetchBranch()
    if (this.branchs.length === 0) {
      this.$toast.open({
        type: 'is-warning',
        message: `ไม่มีสิทธิ์ในการใช้งานกรุณาติดต่อผู้จัดการสาขา`,
        position: 'is-top-right',
        duration: '5000',
        queue: false
      })
    }
    if (this.cancelBtn) {
      let currentBranchID = getBranchID()
      let index = this.branchs.findIndex(obj => obj.id === currentBranchID)
      this.selectBranch = this.branchs[index]
    }
    this.setIsloading(false)
  },
  watch: {
    selectBranch () {
      if (this.selectBranch.posID.length === 0) {
        this.$toast.open({
          type: 'is-warning',
          message: `สาขานี้ไม่มีเครื่อง POS กรุณาติดต่อผู้จัดการสาขา`,
          position: 'is-top-right',
          duration: '5000',
          queue: false
        })
      }
      this.selectPOS = ''
    }
  }
}
</script>

<style>
.body-box {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/selectStore.vue